/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import React from 'react'
import SubmitAction from './SubmitAction/index'
import TysiaIconWarning from 'DesignSystem/Svgs/TysiaIconWarning/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalFooter from 'DesignSystem/TysiaModal/TysiaModalFooter/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/TaskInsertNew/Tags/Content/SearchResult/Content/Tag/DeleteModal/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let constantData = 'Delete'
let tagNameValueData = fromData.useDataValue({ viewPath,
context: 'tag',
path: 'name',
})
let constantData1 = 'tag?'
let aggregateData = fromAggregate.join(constantData, tagNameValueData, constantData1)
let dtColorsYellow600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.yellow.600'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 size="medium"
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 data="'Delete'"
 data="tag.name"
 data="'tag?'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 alignItems="center"
 justifyContent="center"
 position="relative"
>
{childProps => (
<React.Fragment>
<TysiaIconWarning
{...childProps}
  viewPath={`${viewPath}/TysiaIconWarning`}
 fill={dtColorsYellow600}
 height={40}
 width={40}
/>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 marginTop={dtSpaceM}
 size="normal"
 weight="medium"
 color={dtColorsBlack}
 text="Are you sure you wish to remove this tag?"
/>
</React.Fragment>
)}
</TysiaModalContent>
<TysiaModalFooter
{...childProps}
  viewPath={`${viewPath}/TysiaModalFooter`}
>
{childProps => (
<React.Fragment>
<CancelAction
{...childProps}
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
{...childProps}
  viewPath={`${viewPath}/SubmitAction`}
/>
</React.Fragment>
)}
</TysiaModalFooter>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}